import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { AutomapperService } from "../../../../core/automapper/automapper.service";
import { MenuItem } from "../../../../shared/menu/menu-item.model";

@Injectable({
  providedIn: "root",
})
export class AnalyticsHedisService {

  constructor(
    private automapper: AutomapperService,
    private route: Router
  ) { }

  get getAnalyticsRouteFromPath(): string {
    return this.route.url;
  }
}
